import fetch from '@/plugin/axios'

// 新增
export function getSenAdd (query) {
  return fetch({
    url: '/api/member/love-message-theme/add',
    method: 'Post',
    data: query
  })
}

// 修改
export function getSenEdit (id, query) {
  return fetch({
    url: `/api/member/love-message-theme/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 列表
export function getSenList (data) {
  return fetch({
    url: '/api/member/love-message-theme/list',
    method: 'Post',
    data: data
  })
}

// 详情
export function getSenInfo (id) {
  return fetch({
    url: `/api/member/love-message-theme/info/${id}`,
    method: 'Get'
  })
}
// 删除
export function getSenDel (id) {
  return fetch({
    url: `/api/member/love-message-theme/remove/${id}`,
    method: 'Get'
  })
}

// 新增关键词
export function getKeywordAdd (query) {
  return fetch({
    url: '/api/member/love-message-keyword/add',
    method: 'Post',
    data: query
  })
}

// 关键词列表
export function getKeywordList (data) {
  return fetch({
    url: '/api/member/love-message-keyword/list',
    method: 'Post',
    data: data
  })
}

// 详情关键词
export function getKeywordInfo (id) {
  return fetch({
    url: `/api/member/love-message-keyword/info/${id}`,
    method: 'Get'
  })
}
// 修改关键词
export function getKeywordEdit (id, query) {
  return fetch({
    url: `/api/member/love-message-keyword/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 删除关键词
export function getKeywordDel (id) {
  return fetch({
    url: `/api/member/love-message-keyword/remove/${id}`,
    method: 'Get'
  })
}
